import { ReactNode } from "react";
import { cn } from "@drpcrd/utils/shared";
import { Typography } from "../typography";

type Props = {
  pageIcon?: ReactNode;
  title?: ReactNode;
  titleSize?: "sm" | "base" | "lg";
  titleDescGapSize?: "sm" | "md" | "none";
  description?: ReactNode;
  children?: ReactNode;
  className?: string;
  rightElement?: ReactNode;
};

/**
 * Header component for creator pages displaying title, description, and optional icons
 */
export const CreatorPageSection = ({
  pageIcon,
  title,
  titleSize = "lg",
  titleDescGapSize = "sm",
  description,
  children,
  className,
  rightElement,
}: Props) => (
  <div className={cn("mt-3 flex w-full flex-col gap-3", className)}>
    {/* Icon and Title Description */}
    {(pageIcon || title || description) && (
      <div className={cn("mb-1 flex flex-col gap-1", pageIcon && "gap-2!")}>
        {pageIcon}

        {/* Title and Description */}
        {(title || description) && (
          <div className="flex flex-row items-center">
            {/* Texts */}
            <div
              className={cn(
                "flex flex-col",
                titleDescGapSize === "sm"
                  ? "gap-1"
                  : titleDescGapSize === "none"
                    ? "gap-0"
                    : "gap-3",
              )}
            >
              {typeof title == "string" ? (
                <Typography size={titleSize} weight="semibold">
                  {title}
                </Typography>
              ) : (
                title
              )}

              {description && <div className="mb-1">{description}</div>}
            </div>

            {/* Right Element */}
            {rightElement && <div className="ml-auto">{rightElement}</div>}
          </div>
        )}
      </div>
    )}

    {/* Section Content */}
    {children && children}
  </div>
);
